
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/helpHome/blocks/actionItem.scss.css.virtualfile';
        module.exports = {"helpHomeActionItem":"_helpHomeActionItem_1rfqo_7"};